export * from 'server/models/PSixVesselTonnage';


// WEBPACK FOOTER //
// ./data/models/PSixVesselTonnage.ts